import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useEditVarientMutation, useGetVarientByIdQuery } from "../../Services/ProductAPI";


function Addvarients() {
    const navigate = useNavigate();
    const { id, productId } = useParams();
    const [varientName, setvarientName] = useState("");
    const [variantValues, setVariantValues] = useState([""]);
    const [errors, setErrors] = useState({});
    const [apiError, setApiError] = useState(null);


    const [addVarients, { isLoading }] = useEditVarientMutation();
    const { data, isLoading: loadingContent, error, refetch } = useGetVarientByIdQuery(id);
   

    // Populate form fields when data is loaded
    useEffect(() => {
        if (data) {
            setvarientName(data.name || "");
            setVariantValues(data.values?.map(item => item.value) || [""]);
        }
    }, [data]);

    useEffect(()=>{
        refetch();
    }, [refetch])

    const validateForm = () => {
        let newErrors = {};
        if (!varientName.trim()) newErrors.varientName = "Name is required";
        if (variantValues.some(value => !value.trim())) newErrors.variantValues = "All variant fields are required";
        

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        const formData = {
            name: varientName,
            values: variantValues,
            product_id:productId,
        };

        try {
            await addVarients({ formData, id }).unwrap();
            alert("Variant updated successfully!");
            navigate(`/list-varients`);
        } catch (error) {
            setApiError(error.data?.message || "Something went wrong");
        }
    };

    const handleAddVariant = () => {
        setVariantValues([...variantValues, ""]);
    };

    const handleRemoveVariant = (index) => {
        const updatedVariants = [...variantValues];
        updatedVariants.splice(index, 1);
        setVariantValues(updatedVariants);
    };

    const handlevarientNameChange = (e) => {
        setvarientName(e.target.value);
        if (errors.varientName) {
            setErrors((prevErrors) => ({ ...prevErrors, varientName: undefined }));
        }
    };


    const handleVariantChange = (index, value) => {
        const updatedVariants = [...variantValues];
        updatedVariants[index] = value;
        setVariantValues(updatedVariants);

        if (errors.variantValues) {
            setErrors((prevErrors) => ({ ...prevErrors, variantValues: undefined }));
        }
    };

    if (loadingContent) return <div className="loader"></div>;
    if (error) return <p>Failed to load Data</p>;

    return (
        <div>
            <h3>{id ? "Edit Variants" : "Add Variants"}</h3>
            <div className="breadcrum mb-4">
                <p>
                <Link to={`/list-varients`}><span>Variants</span></Link>
                    <FontAwesomeIcon icon={faAngleRight} className="mx-2" />
                    <span className="active-link">{id ? "Edit" : "Add"}</span>
                </p>
            </div>
            <div className="content-wrapper">
                <form onSubmit={handleSubmit} encType="multipart/form-data">
                    <div className="row">
                        <div className="col-md-6 col-sm-12 col-lg-6">
                            <div className="mb-4 text-start">
                                <label htmlFor="category_name" className="form-label">Variant Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="category_name"
                                    placeholder="Enter Variant Name"
                                    value={varientName}
                                    onChange={handlevarientNameChange}
                                />
                                {errors.varientName && <p className="text-danger">{errors.varientName}</p>}
                            </div>
                        </div>

                        {/* <div className="col-md-6 col-sm-12 col-lg-6">
                            <div className="mb-4 text-start">
                                <label htmlFor="category_name" className="form-label">Select Category</label><br />
                                <select onChange={handleCategoryNameChange} value={categoryName} className="form-control">
                                    <option value="">Select</option>
                                    {allCategories?.data?.map((item) => (
                                        <option value={item.id}>{item.category_name}</option>
                                    ))}
                                </select>
                                {errors.categoryName && <p className="text-danger">{errors.categoryName}</p>}
                            </div>
                        </div> */}

                    </div>

                    <div className="row">
                        <div className="col-md-6 col-sm-12 col-lg-6">
                            <div className="mb-4 text-start">
                                <label className="form-label">Variant Values</label>
                                {variantValues.map((value, index) => (
                                    <div key={index} className="d-flex mb-2">
                                        <input
                                            type="text"
                                            className="form-control me-2"
                                            placeholder={`Enter Variant ${index + 1}`}
                                            value={value}
                                            onChange={(e) => handleVariantChange(index, e.target.value)}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-danger"
                                            onClick={() => handleRemoveVariant(index)}
                                            disabled={variantValues.length === 1}
                                        >
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                    </div>
                                ))}
                                {errors.variantValues && <p className="text-danger">{errors.variantValues}</p>}
                                <button type="button" className="btn btn-success mt-2" onClick={handleAddVariant}>
                                    <FontAwesomeIcon icon={faPlus} /> Add Variant
                                </button>
                            </div>
                        </div>
                    </div>

                    {apiError && <p className="text-danger text-center">{apiError}</p>}

                    <button type="submit" className="btn btn-primary" disabled={isLoading}>
                        {isLoading ? "Submitting..." : "Submit"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default Addvarients;
